import { Controller } from "@hotwired/stimulus"

export default class HeroImagePickerController extends Controller {
  static targets = [
    "modal",
    "grid",
    "preview",
    "previewImage",
    "placeholder",
    "imageUrlInput",
    "fileInput",
    "urlInput",
    "clearBtn"
  ]

  static values = {
    currentCategory: { type: String, default: "all" }
  }

  connect() {
    this._boundHandleKeydown = this.handleKeydown.bind(this)

    // 기존 imageUrlInput 값이 있으면 미리보기 표시, 없으면 명시적으로 숨김
    if (this.hasImageUrlInputTarget && this.imageUrlInputTarget.value) {
      this._showPreview(this.imageUrlInputTarget.value)
    } else {
      this._hidePreview()
    }
  }

  disconnect() {
    document.removeEventListener("keydown", this._boundHandleKeydown)
  }

  open(event) {
    event.preventDefault()
    this.modalTarget.style.display = "flex"
    document.body.style.overflow = "hidden"
    document.addEventListener("keydown", this._boundHandleKeydown)
  }

  close() {
    this.modalTarget.style.display = "none"
    document.body.style.overflow = ""
    document.removeEventListener("keydown", this._boundHandleKeydown)
  }

  closeOnBackdrop(event) {
    if (event.target === this.modalTarget) {
      this.close()
    }
  }

  handleKeydown(event) {
    if (event.key === "Escape") {
      this.close()
    }
  }

  selectCategory(event) {
    const category = event.currentTarget.dataset.category
    this.currentCategoryValue = category

    // 이미지 아이템 필터링
    const items = this.gridTarget.querySelectorAll(".hero-picker__img-item")
    items.forEach(item => {
      if (category === "all" || item.dataset.category === category) {
        item.style.display = ""
      } else {
        item.style.display = "none"
      }
    })

    // 탭 active 상태 업데이트
    const tabs = this.element.querySelectorAll("[data-action*='selectCategory']")
    tabs.forEach(tab => {
      tab.classList.remove("hero-picker__tab--active")
    })
    event.currentTarget.classList.add("hero-picker__tab--active")
  }

  selectImage(event) {
    const path = event.currentTarget.dataset.path

    this.imageUrlInputTarget.value = path
    this._showPreview(path)

    // 그리드 내 선택 표시 초기화 후 클릭된 항목에 선택 표시 추가
    const items = this.gridTarget.querySelectorAll(".hero-picker__img-item")
    items.forEach(item => {
      item.classList.remove("hero-picker__img-item--selected")
    })
    event.currentTarget.classList.add("hero-picker__img-item--selected")

    // 200ms 후 close (선택 확인용 딜레이)
    setTimeout(() => {
      this.close()
    }, 200)
  }

  triggerFileUpload() {
    this.fileInputTarget.click()
  }

  uploadFile(event) {
    const file = this.fileInputTarget.files[0]
    if (!file) return

    const reader = new FileReader()
    reader.onload = (e) => {
      this._showPreview(e.target.result)
      this.imageUrlInputTarget.value = "" // 파일 우선, URL 인풋 초기화
      this.close()
    }
    reader.readAsDataURL(file)
  }

  applyUrl() {
    const url = this.urlInputTarget.value.trim()
    if (!url) return

    this.imageUrlInputTarget.value = url
    this._showPreview(url)
    this.close()
  }

  clearSelection() {
    this.imageUrlInputTarget.value = ""
    this._hidePreview()

    // 그리드 내 선택 표시 모두 제거
    if (this.hasGridTarget) {
      const items = this.gridTarget.querySelectorAll(".hero-picker__img-item")
      items.forEach(item => {
        item.classList.remove("hero-picker__img-item--selected")
      })
    }

    // 파일 인풋 초기화 (가능할 때)
    try {
      this.fileInputTarget.value = ""
    } catch (_e) {
      // 일부 브라우저에서 파일 인풋 초기화 불가
    }
  }

  // --- private helpers ---

  _showPreview(url) {
    this.previewImageTarget.src = url
    this.previewImageTarget.style.display = ""
    this.previewTarget.style.display = "inline-flex"
    this.placeholderTarget.style.display = "none"
    this.clearBtnTarget.style.display = "inline-flex"
  }

  _hidePreview() {
    this.previewImageTarget.src = ""
    this.previewImageTarget.style.display = ""
    this.previewTarget.style.display = "none"
    this.placeholderTarget.style.display = "block"
    this.clearBtnTarget.style.display = "none"
  }
}
